import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { AsyncPipe, CommonModule } from '@angular/common';

@Component({
  selector: 'formly-select',
  template: `
    <select
      [formControl]="formControl"
      [formlyAttributes]="field"
      class="select select-bordered w-full focus:outline-none"
    >
      <ng-container *ngFor="let option of to.options | formlySelectOptions: field | async">
        <option [value]="option.value">{{ option.label }}</option>
      </ng-container>
    </select>
  `,
  imports: [ReactiveFormsModule, FormlyModule, FormlySelectModule, AsyncPipe, CommonModule],
})
export class FormlySelectComponent extends FieldType {
  override get formControl(): FormControl {
    return super.formControl as FormControl;
  }
}
